// auth.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ForcePasswordChangeService } from '../services/force-password-change.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService,
    private forcePasswordChange: ForcePasswordChangeService
  ) {}

  canActivate(): boolean {
    try {
      this.authService.validateToken();
      if (this.authService.promptNewPassword) {
        this.forcePasswordChange.ensureOpen();
      }
      return true;
    } catch (error) {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
